import difference from 'lodash/difference';

export function isKudosExist(kudos) {
  return kudos?.gifUrl || kudos?.likeThatText || kudos?.likeThatVideo;
}

function checkOption(array, item, checked) {
  if (array) return array.some(e => e === item);
  if (!item) return false;
  return checked;
}

export function formatOption({ array = undefined, editable = false, checked = false, freeze = false }) {
  return item => {
    const isCheck = checkOption(array, item, checked);
    return { checked: isCheck, label: item, editable, freeze };
  };
}

export function optionsDecorator({ options, presetOptions, freezeOptions = [], differenceOptions }) {
  const filteredDefaultValues = presetOptions.filter(value => !freezeOptions.some(item => item === value));

  return [
    ...freezeOptions.map(formatOption({ freeze: true, checked: false, editable: false })),
    ...filteredDefaultValues.map(formatOption({ array: options })),
    ...(differenceOptions || difference(options, presetOptions)).map(formatOption({ checked: true, editable: true })),
  ];
}

export function outputOptionsDecorator(items) {
  return items.filter(item => item.label && item.checked).map(item => item.label);
}
